import { Dialog, DialogActions, DialogContent, List, ListItem, ListItemText, Typography } from '@mui/material';
import { CustomDialogTitle } from '../../../Modules/Common/Custom/CustomDialogTitle';
import { MDBox } from "./MDBox";
import { MDButton } from './MDButton';
import { MDTypography } from './MDTypography';

interface IProps {
    showDialog: boolean;
    heading: string;
    message: string;
    messageList?: string[];
    handleAccept: () => void;
}

export const InformationDialog = (props: IProps) => {

    return (
        <Dialog open={props.showDialog} onClose={props.handleAccept} aria-labelledby="form-dialog-title" maxWidth='md'>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.handleAccept}>
                {props.heading}
            </CustomDialogTitle>
            <DialogContent>
                <MDBox>
                    <MDTypography variant="button" fontWeight='regular' fontSize="0.9em">
                        {props.message}
                    </MDTypography>
                    {props.messageList &&
                        <ul style={{ listStyle: "none" }}>
                            {props.messageList.map(item => {
                                return (
                                    <li>
                                        <MDTypography variant="button"fontWeight="bold" fontSize="0.9em">{item}</MDTypography>
                                    </li>
                                )
                            })}
                        </ul>
                    }
                </MDBox>
            </DialogContent>
            <DialogActions>
                <MDBox display="flex" justifyContent="space-between">
                    <MDButton color="primary" variant="contained" onClick={props.handleAccept}>
                        Ok
                    </MDButton>
                </MDBox>
            </DialogActions>
        </Dialog>
    )
}